export enum ServiceDisplayMode {
  GRID = "GRID",
  MENU = "MENU",
  CATEGORY_SIDEBAR = "CATEGORY_SIDEBAR",
}
